<template>
    <div class="container-fluid">
        <!-- home -->
        <hero-section />

        <!-- /.home -->
        <service-package :slick-config="slickConfig" />

        <!-- Lading section - FEACHED FROM CMS -->
        <landing-sections v-if="!POS_MODE" />
        <!-- /.bld-intro-text -->
        <!-- bld-by-experts -->
        <div class="row pos-r bg-white section-global">
            <div class="static-pages">
                <div class="static-pages-title ">
                    <div class="container">
                        <!-- expert-content -->
                        <div class="content-holder">
                            <div class="text-wrapper-wide">
                                <div class="content-title-holder">
                                    <h2 class="text-upper">Built by experts, with an eye for design</h2>
                                </div>
                                <p>
                                    NZXT has more than 12 years of experience developing award winning, high-quality PC components. By using the very best components,
                                    assembled by highly-trained builders, we can deliver a meticulously crafted gaming PC,
                                    backed by a comprehensive 2-year warranty.
                                </p>
                                <router-link to="/what-is-bld" class="btn btn-green m-y-md">LEARN MORE</router-link>
                            </div>
                            <div class="intro-image">
                                <img src="/images/section-images/footer/H710i-footer-pc.jpg" alt="" class="img-response-w">
                            </div>
                        </div>
                        <!-- /.expert-content -->
                    </div>
                </div>
            </div>
        </div>
        <!-- /.bld-by-experts -->
        <div class="row">
            <!-- BLD Refurbished Builds -->
            <div class="col-xs-12 col-lg-6">
                <div v-if="!POS_MODE" class="row refurbished-builds-section bg-green">
                    <div class="col-xs-12">
                        <div class="static-pages">
                            <div class="static-pages-title">
                                <h2>
                                    CHECK OUT DEALS ON<br>
                                    REFURBISHED BUILDS
                                </h2>
                                <router-link to="refurbished-builds" class="btn btn-white">LEARN MORE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- BLD Refurbished Builds -->
            <!-- BLD B2B Bulk Purchase -->
            <div class="col-xs-12 col-lg-6">
                <div v-if="!POS_MODE" class="row bulk-purchase-section">
                    <div class="col-xs-12">
                        <div class="static-pages">
                            <div class="static-pages-title">
                                <h2>
                                    PURCHASING IN BULK<br>
                                    FOR YOUR BUSINESS?
                                </h2>
                                <router-link to="bulk-purchase" class="btn btn-purple">Get in touch</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- BLD B2B Bulk Purchase -->
        </div>
        <!-- media-quotes -->
        <div class="row">
            <div class="col-xs-12 media-quotes bg-black p-x-lg p-y-lg clearfix p-a-0">
                <div class="mq-content col-xs-12 p-a-0">
                    <div class="mq-text">
                        <!-- forge -->
                        <div class="mq-logo text-center m-y">
                            <i class="ninja-logotype-white" />
                        </div>
                        <p class="text-white text-center">
                            "Their BLD program translates hardware into performance. Finally, no one will ever wonder how good their computer will perform in the games they want to play."
                        </p>
                    </div>
                </div>
                <div class="mq-content col-xs-12 p-a-0">
                    <div class="mq-text">
                        <!-- kotaku -->
                        <div class="mq-logo text-center m-y">
                            <i class="logo-site-kotaku" />
                        </div>
                        <p class="text-white text-center">
                            "There’s something lovely about having a PC that comes with a set of guaranteed predicted frames-per-second targets for the
                            games I planned."
                        </p>
                    </div>
                </div>
                <div class="mq-content col-xs-12 p-a-0">
                    <div class=" mq-text">
                        <!-- Pc Gamer -->
                        <div class="mq-logo text-center m-y">
                            <i class="pcg-logo-hires" />
                        </div>
                        <p class="text-white text-center">
                            "Offering real-world performance data is a great idea, and makes the process of ordering a PC much less abstract for newcomers."
                        </p>
                    </div>
                </div>
                <div class="mq-content col-xs-12 p-a-0">
                    <div class="mq-text">
                        <!-- Techradar -->
                        <div class="mq-logo text-center m-y">
                            <i class="techradar-logo" />
                        </div>
                        <p class="text-white text-center">
                            "This is certainly a very neat idea, and the company is putting its money where its mouth is regarding the frame-rate estimations."
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.media-quotes -->
    </div>
</template>

<script>
import { heapAnalytics } from "../util/mixins";
import CONSTANTS from "@/config/constants";
import landingSections from "./landing-sections/sections";
import heroSection from "./hero-section/hero-container";
import ServicePackage from "./service-package";

export default {
    name: "Index",
    components: {
        landingSections,
        heroSection,
        ServicePackage
    },
    mixins: [heapAnalytics],
    data() {
        return {
            slickConfig: {
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplaySpeed: 4000,
                responsive: [
                    {
                        breakpoint: 1366,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 770,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            isProduction: CONFIG.PRODUCTION
        };
    },
    watch: {
        "$route": {
            handler(to) {
                if (to.query.login) {
                    this.$modal.show('login-modal');
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.initialize();
    },
    beforeDestroy() {
        EventBus.$off("april-fools");
    },
    methods: {
        initialize() {
            $("body").scrollspy({
                target: "#navbar-spy"
            });
            $(".media-quotes").slick(this.slickConfig);
        }
    }
};
</script>
